module.exports = __webpack_public_path__ + "static/media/ic_hs_b2_myway.a0abc108.svg";